module.exports = __webpack_public_path__ + "assets/img/fe84d526625a2e1eb536008d4deb9910.png";